import { graphql } from "../../services/wp.api.service";

const query = `
	query userProfileQuery($id: ID!) {
		user(id: $id, idType: DATABASE_ID) {
			email
			firstName
			lastName
			userProfile {
				age
				communications
				country
				education
				gender
				industry
				position
				race
				state
				workStatus
				zip
			}
		}
	}
`;

const transformRespondent = (user) => {
	const profile = user.userProfile;
	delete user.userProfile;
	return { ...user, ...profile }
};

const profileQuery = (useQuery, id, options) => {
	const variables = {
		id: parseInt(id, 10),
		useErrorBoundary: true
	};

	return useQuery(
		["userProfile", id],
		() => graphql({
			query,
			variables
		}).
			then((res) => transformRespondent(res.data.data.user)),
		{
			staleTime: 10 * 60 * 1000,
			...options
		}
	);
};

export default profileQuery;
